import { useEffect, useState } from 'react'

const CLOCK_MS = 1000

/**
 * A clock that ticks once a second, deliberately separate from the live feed.
 *
 * It talks to nobody. All it does is put the current time into state, which
 * makes React re-render — and that is what keeps the relative "since" column
 * and the row highlights moving while the server is quiet.
 *
 * Without it, "is this row's highlight deadline in the past yet?" would only
 * ever be asked once, and a highlighted row would stay lit forever.
 */
export function useNow() {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), CLOCK_MS)

    // Stop the timer when the page closes, or it keeps ticking forever.
    return () => clearInterval(id)
  }, [])

  return now
}
